import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import BasicAreaLineChart from 'components/common/chart/BasicAreaLineChart';
import { ReactComponent as WindSvg } from '../../../../assets/icons/wind.svg';

const WindTurbine = () => {
  const data = [
    766.5, 613.2, 766.5, 689.8, 613.2, 613.2, 459.9, 459.9, 536.5, 613.2, 689.8,
    766.5, 689.8
  ];

  const doubledData = data.map(num => num * 2);

  return (
    <>
      <Col md={12} className="border-bottom pb-2">
        <Row className="mx-0">
          <Col xs={6} className="py-2 centered-column">
            <h6 className="text-600">Total Turbines</h6>
            <WindSvg className="land-dev-icon-40 mb-1" />
            <h5 className="fw-normal text-500 mb-0">2</h5>
          </Col>
          <Col xs={6} className="pb-2">
            <Flex justifyContent="between" alignItems="center" className="py-2">
              <h6 className="text-600 mb-0">Turbine Capacity</h6>
              <h5 className="fw-normal text-500 mb-0">3.5 kW</h5>
            </Flex>
            <Flex justifyContent="between" alignItems="center" className="py-2">
              <h6 className="text-600 mb-0">Capacity Factor</h6>
              <h5 className="fw-normal text-500 mb-0">30%</h5>
            </Flex>
            <Flex justifyContent="between" alignItems="center" className="pt-2">
              <h6 className="text-600 mb-0">Energy Output</h6>
              <h5 className="fw-normal text-500 mb-0">15,120 kWh</h5>
            </Flex>
          </Col>
        </Row>
      </Col>
      <Col md={12} className="border-bottom py-2 height-22">
        <Row className="mx-0">
          <h6 className="text-600 mb-0">Annunal Energy Output (kWh)</h6>
          <BasicAreaLineChart data={doubledData} />
        </Row>
      </Col>
      <Col md={12} className="py-2">
        <Flex justifyContent="between" alignItems="center" className="py-2">
          <h6 className="text-600 mb-0">Initial Cost</h6>
          <h6 className="text-600 mb-0">$ 24,000</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Annunal Maintenance Cost</h6>
          <h6 className="text-600 mb-0">$ 600</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Annunal Carbon Avoided</h6>
          <h6 className="text-600 mb-0">7,6 tCO2e</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center">
          <h6 className="text-600 mb-0">Carbon Credit Revenue</h6>
          <h6 className="text-600 mb-0">$ 380</h6>
        </Flex>
      </Col>
    </>
  );
};
export default WindTurbine;
